
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clearyourdebtsfast/privacy-policy",
      function () {
        return require("private-next-pages/clearyourdebtsfast/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clearyourdebtsfast/privacy-policy"])
      });
    }
  